import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import iconMap from "../../../../assets/icons/Icons";
import { OverallBg, ThemeBasedColorHeader, ThemeBasedColorMenubar } from "src/shared/modules/profile/theme/themeCheacker";

function ProfileMenu() {
  const location = useLocation();
  const [isMobileDropdown, setIsMobileDropdown] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobileDropdown(window.innerWidth < 900);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const menuItems = [
    // { icon: iconMap["myProfile"], path: "/grocery/setting/my-profile", name: "Profile" },
    { icon: iconMap["employee"], path: "/grocery/setting/work-profile", name: "Business Profile" },
    { icon: iconMap["theme"], path: "/grocery/setting/theme", name: "Themes" },
    { icon: iconMap["configuration"], path: "/grocery/setting/configuration", name: "Configration" },
  ];

  return (
    <div className='w-full p-1'>
      <div
        className={`flex flex-wrap md:flex-nowrap overflow-hidden ml-1 mr-4 mt-2 pl-1 py-1 rounded-lg ${ThemeBasedColorMenubar()} shadow-inner shadow-indigo-500/50 items-center`}
      >
        {menuItems.map(({ icon: IconComponent, path, name }) => {
          const isActive = location.pathname.startsWith(path);

          return (
            <Link
              to={path}
              key={path}
              className={`flex gap-2 items-center font-bold py-1 px-5 h-10 m-1 transition duration-300 transform whitespace-nowrap ${
                isActive
                  ? `scale-100 text-black mt-2 -mb-3 rounded-t-lg shadow-md shadow-gray-500 ${OverallBg()}`
                  : `hover:text-white hover:scale-95 border ${ThemeBasedColorHeader()} rounded-lg shadow shadow-gray-400`
              }`}
            >
              <IconComponent />
              <span className={`text-sm truncate ${isMobileDropdown && "hidden"}`} title={name}>
                {name}
              </span>
            </Link>
          );
        })}
      </div>
    </div>
  );
}

export default ProfileMenu;
